import React from 'react'

// MUI
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

const SupGroupList = (props) => {
  const { classes, groupsList = [], findSupervisorName, setSupGroupForm, handleEditGroup } = props

  // Sorted supervisor group member names
  const SortedSupervisorNames = ({ groupSupervisors }) => {
    if (!groupSupervisors || !groupSupervisors.length) { return <Grid item xs={12}>No Members Assigned</Grid> }

    const formattedNames = groupSupervisors
      .map(supervisor => findSupervisorName(supervisor.supervisorID))
      .filter(name => name !== '') // remove empty names (should not happen)
      .sort((a, b) => a.localeCompare(b)) // sort alphabetically

    return (
      <>
        {formattedNames.map((name, index) => (
          <Grid item xs={12} md={6} key={`supervisor-${index}`}>
            <Typography variant='overline'>
              {name}
            </Typography>
          </Grid>
        ))}
      </>
    )
  }

  return (
    <Grid container direction='row' justify='flex-start'>
      <Grid container item direction='column' spacing={2} className='m-auto w-100'>

        <Grid container item direction='row' justify='flex-start'>
          <Grid item>
            <Button size='large' variant='contained' className={classes.greenBtn} onClick={() => setSupGroupForm('new')}>
              Create New Group
            </Button>
          </Grid>
        </Grid>

        <Grid container item direction='row'>
          <Grid container item direction='column' spacing={3} className='w-100 m-auto'>
            {/* Map through groups */}
            {
              groupsList.reduce((arr, groupInfo) => {
                if (groupInfo && groupInfo.groupID) {
                  const { groupID, groupName, unitName: groupUnitName, supervisors: groupSupervisors, groupDesc } = groupInfo

                  arr.push(
                    <Grid item key={`group-${groupID}`} container direction='row' className='px-0'>
                      <Card raised className={classes.userCard}>
                        <CardContent>
                          <Grid container direction='row'>
                            <Grid container item direction='column' spacing={1} className='m-auto w-100'>

                              <Grid item container direction='row' className='px-0'>
                                <Grid item container direction='column'>

                                  <Grid item container direction='row' justify='space-between' spacing={2} className='m-auto w-100'>
                                    <Grid item xs={12} sm={6} className='pl-0'>
                                      <Grid container item direction='row' spacing={1} className='mx-auto w-100' alignItems='center'>
                                        <Grid item className='pl-0'>
                                          <Typography className='text-primary font-weight-bold mr-1' style={{ textTransform: 'none' }} variant='h6'>Group:</Typography>
                                        </Grid>

                                        <Grid item className='pr-0'>
                                          <Typography style={{ textTransform: 'none', fontWeight: 'bold' }} variant='button'>{groupName}</Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                      <Typography className='text-muted' variant='subtitle1' style={{ textTransform: 'none', fontWeight: 'bold' }}>{groupUnitName}</Typography>
                                    </Grid>

                                    <Grid item xs={12} sm={2} className='pr-0'>
                                      <Grid item>
                                        <Button
                                          variant='contained'
                                          fullWidth
                                          className={classes.greenBtn}
                                          onClick={() => handleEditGroup(groupInfo)}
                                        >
                                          <span className='font-weight-bold'>Edit</span>
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </Grid>

                                  <Grid item container direction='row'>
                                    <Grid item xs={12}>
                                      <Divider />
                                    </Grid>
                                  </Grid>

                                </Grid>
                              </Grid>

                              <Grid item container direction='row' className='px-0 m-auto w-100' spacing={1}>
                                <Grid item className='py-0 pl-0'>
                                  <Typography className='text-primary font-weight-bold mr-1' gutterBottom style={{ textTransform: 'none' }} variant='subtitle1'> Description:</Typography>
                                </Grid>

                                <Grid item className='py-0 pr-0'>
                                  <Typography className='text-muted' variant='subtitle1' style={{ textTransform: 'none' }}>{groupDesc}.</Typography>
                                </Grid>
                              </Grid>

                              <Grid item container direction='row' className='px-0'>
                                <Grid container item direction='column'>
                                  <Grid item container direction='row'>
                                    <Grid item>
                                      <Typography className='text-primary font-weight-bold' gutterBottom style={{ textTransform: 'none' }} variant='subtitle1'> Members:</Typography>
                                    </Grid>
                                  </Grid>

                                  <Grid item container direction='row' className={classes.supervisorList} justify='flex-start' spacing={1}>
                                    <SortedSupervisorNames groupSupervisors={groupSupervisors} />
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>

                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  )
                }

                return arr
              }, [])
            }
            {/* end  group map */}
          </Grid>
        </Grid>

      </Grid>
    </Grid>
  )
}

export default SupGroupList
